export default __webpack_public_path__ + "static/media/logo.be626bf9.png";